import React from 'react'
import Img from "./images/under-construction.png"

const UnderContruction = () => {
  return (
    <div className='flex-center flex-col gap-[1vmax] mt-[5vmax]' >
        <h2 className='text-[2.5vmax] font-[900] font-3 text-black' >
            Page under Construction
        </h2>
        <img src={Img} alt='' className='w-[70%] lg:w-[30%]' />
        <p className='w-[70%] lg:w-[50%] text-center text-[1.5vmax] lg:text-[1.1vmax] text-gray-600 font-3' >This page is currently under construction. We’re working hard to bring it to you soon. Thank you for your patience.</p>
    </div>
  )
}

export default UnderContruction